// テキストデータ
export default {
  JP: {
    top: {
      text: '日本中のミュージアムを \n このアプリひとつで歩けるように'
    },
    btnNews: {
      text: 'お知らせはこちら'
    },
    explaination: {
      title: 'ポケット学芸員®とは',
      text1: '「ポケット学芸員」は、学芸員が展示物に付した解説文やナレーションを、あなたのスマートフォンで楽しむことができる無料のアプリです。',
      text2: '「ポケット学芸員」があれば、日本中のたくさんのミュージアムのガイドを利用できます。それは、たくさんの施設で「ポケット学芸員」が提供されているから。',
      text3: '「ポケット学芸員」は、そんな「ミュージアム好き」のためのアプリ。ミュージアム巡りのおともに、ダウンロードしてみてください。'
    },
    place: {
      title: 'サービス提供施設',
      text: '「ポケット学芸員」は、現在、以下のミュージアムでご利用いただけます。 \n サービス提供館は、今後も増えていく予定ですので、どうぞお楽しみに。',
      btn1: '現在地から近い施設を検索',
      btn2: 'すべて',
      region1: '北海道',
      region2: '東北',
      region3: '関東',
      region4: '中部',
      region5: '近畿',
      region6: '中国・四国',
      region7: '九州・沖縄'
    },
    operation: {
      title: '操作は簡単',
      text1: '利用したい施設を選びます。 \n 現在地の近くの施設を探したり、施設の名前で検索したりできます。',
      text2: '一覧でいくつかの施設が表示されたら、見たい施設を選びます。',
      text3: '施設のプロフィールが表示されます。展示を鑑賞するときは「ガイド」を選んで番号入力に進みます。 \n 「リスト」を選ぶと、展示物のリストが表示されます。「ダウンロード」を選ぶとその施設のデータがスマートフォンにダウンロードされますが、データは24時間後に消去されます。',
      text4: '展示物に付されている番号を入力し、「決定」にタッチします。',
      text5: '展示物の解説や画像などの情報が表示されます 。音声や動画がある場合は、再生ボタンが表示されます。動画はYouTubeに限定公開でアップしたものがアプリ内で再生されますので、インターネットに接続しておく必要があります。'
    },
    footer: {
      company: '運営会社'
    },
    modal: {
      title: '検索結果',
      error1: '現在地近くに利用できる施設はありません（該当施設なし）',
      error2: '位置情報サービスを有効にしてください '
    }
  },
  EN: {
    top: {
      text: 'Making it possible to walk through museums \n throughout Japan with this single application'
    },
    btnNews: {
      text: 'Notices are here'
    },
    explaination: {
      title: 'About "POCKET CURATOR®"',
      text1: '"POCKET CURATOR" is a free application that lets you enjoy written explanation and narration from curators about the displayed items on your own smartphone.',
      text2: 'With "POCKET CURATOR", you can use guides from many museums across Japan. This is because "POCKET CURATOR" is provided at many museums.',
      text3: '"POCKET CURATOR" is an application for that kind of museum enthusiast. Please bring it with you around the museums and try downloading.'
    },
    place: {
      title: 'Museums offering the service',
      text: '"POCKET CURATOR" is currently being used by the following museums. \n We plan to continue expanding the number of museums offering this service, so please look forward to it.',
      btn1: 'Search for museums near here',
      btn2: 'All',
      region1: 'Hokkaido',
      region2: 'Tohoku region',
      region3: 'Kanto region',
      region4: 'Chubu region',
      region5: 'Kinki region',
      region6: 'Chugoku & Shikoku',
      region7: 'Kyushu & Okinawa'
    },
    operation: {
      title: 'Easy to operate',
      text1: 'You choose the museum you want to use. \n You can search for a museum near your current location or search using the name of the museum.',
      text2: 'When several museums are displayed in a list, you choose the museum you want to see.',
      text3: 'The museum profile will be displayed. When viewing the exhibit, choose "Guide" and proceed by entering the number. \n If you choose "List," a list of items being exhibited will be displayed. If you choose "Download," the data from that museum will be downloaded onto your smartphone, but that data will be deleted 24 hours later.',
      text4: 'Input the number corresponding to the exhibited item and tap "Set".',
      text5: 'Information such as explanations and pictures of exhibits is displayed. To enjoy replaying sounds and animations, please tap the replay button.'
    },
    footer: {
      company: 'Service operation'
    },
    modal: {
      title: 'result',
      error1: 'There is no facility available near your current location.',
      error2: 'Please enable location services.'
    }
  },
  CN: {
    top: {
      text: '依靠这一种应用 \n 走遍日本各地的博物馆'
    },
    btnNews: {
      text: '通知见此处'
    },
    explaination: {
      title: '何谓掌上文艺人员',
      text1: '“掌上文艺人员”是一款免费应用，能够通过您的智能手机为您带来文艺人员关于展品的解说及旁白。',
      text2: '有了“掌上文艺人员”将能够使用日本国内多个博物馆的向导。这是因为众多设施中提供有“掌上文艺人员”的服务。',
      text3: '“掌上文艺人员”是专为“博物馆爱好者”开发的应用。敬请在游览博物馆时下载使用。'
    },
    place: {
      title: '服务提供设施',
      text: '“掌上文艺人员”当前可在以下博物馆中使用。 \n 提供服务的博物馆今后还将继续增加，敬请期待。',
      btn1: '通过当前位置搜索附近设施',
      btn2: '所有',
      region1: '北海道',
      region2: '东北',
      region3: '关东',
      region4: '中部',
      region5: '近畿',
      region6: '中国・四国',
      region7: '九州・冲绳'
    },
    operation: {
      title: '操作十分简单',
      text1: '选择想要前往的设施。 \n 可就近搜索当前所在地附近的设施或通过设施名称搜索。',
      text2: '一览中显示多个设施时选择希望游览的设施。',
      text3: '画面中会显示设施简介。鉴赏展示内容时选择“向导”进入号码输入。 \n 选择“列表”后将显示展品列表。选择“下载”后该设施的数据将会下载至智能手机中，但该数据会在24小时之后删除。',
      text4: '输入展品附带的号码，点击“确定”',
      text5: '画面中会显示展品解说及图像等信息。\n 有音频或视频时，请点击播放按钮进行听讲或观看。'
    },
    footer: {
      company: '服务运营'
    },
    modal: {
      title: '搜索结果',
      error1: 'There is no facility available near your current location.',
      error2: 'Please enable location services.'
    }
  },
  TW: {
    top: {
      text: '只要安裝這一個App \n 就能走遍全日本的博物館'
    },
    btnNews: {
      text: '通知請點選此處'
    },
    explaination: {
      title: '何謂袖珍文藝人員',
      text1: '「袖珍文藝人員」是能夠透過您的智慧型手機，觀看文藝人員附於展示品的解說文和旁白之免費App。',
      text2: '如果有「袖珍文藝人員」，就能使用全日本許多博物館的導覽。因為在許多設施，提供「袖珍文藝人員」。',
      text3: '「袖珍文藝人員」是為了「博物館愛好者」所設計的App。敬請下載，作為走訪博物館的良伴。'
    },
    place: {
      title: '提供服務設施',
      text: '目前，「袖珍文藝人員」能夠於下列博物館使用。 \n 預定提供服務的博物館今後亦會增加，敬請期待。',
      btn1: '從目前所在地搜尋附近的設施',
      btn2: '全部',
      region1: '北海道',
      region2: '東北',
      region3: '關東',
      region4: '中部',
      region5: '近畿',
      region6: '中國・四國',
      region7: '九州・沖繩'
    },
    operation: {
      title: '操作簡單',
      text1: '選擇想要使用的設施。 \n 能夠尋找目前所在地附近的設施，或者以設施的名稱搜尋。',
      text2: '幾個設施顯示於一覽表之後，選擇想要觀看的設施。',
      text3: '顯示設施的簡介。觀賞展示時，選擇「導覽」，進入輸入編號。 \n 選擇「清單」，就會顯示展示品的清單。選擇「下載」，該設施的資料就會下載至智慧型手機，資料會在24小時後刪除。',
      text4: '輸入附於展示品的編號，輕觸「決定」',
      text5: '顯示展示品的解說和影像等資訊。\n 有聲音和影片的情況下，請輕觸播放按鈕收聽或觀看。'
    },
    footer: {
      company: '營運服務單位'
    },
    modal: {
      title: '搜索結果',
      error1: 'There is no facility available near your current location.',
      error2: 'Please enable location services.'
    }
  },
  KO: {
    top: {
      text: '일본 전역에 있는 뮤지엄을 \n 이 앱 하나로 돌아볼 수 있습니다'
    },
    btnNews: {
      text: '공지사항'
    },
    explaination: {
      title: '포켓 큐레이터란?',
      text1: '‘포켓 큐레이터’는 큐레이터가 준비한 전시물에 대한 해설문이나 내레이션을 당신의 스마트폰으로 즐길 수 있는 무료 앱입니다.',
      text2: '많은 시설에서 ‘포켓 큐레이터’가 제공되고 있습니다.그래서 ‘포켓 큐레이터’가 있으면, 일본 전역에 있는 많은 뮤지엄 가이드를 이용할 수 있습니다.',
      text3: '‘포켓 큐레이터’는 그런 ‘뮤지엄 애호가’를 위한 앱입니다. 뮤지엄 탐방을 위한 동반자로 활용하실 수 있도록, 다운로드해 보십시오.'
    },
    place: {
      title: '서비스 제공 시설',
      text: '‘포켓 큐레이터’는 현재, 아래의 뮤지엄에서 이용하실 수 있습니다. \n 앞으로도 서비스 제공관이 늘어날 예정이오니, 기대해 주시기 바랍니다.',
      btn1: '내 주변 시설 검색',
      btn2: '전체',
      region1: '홋카이도',
      region2: '도호쿠',
      region3: '간토',
      region4: '주부',
      region5: '긴키',
      region6: '주고쿠・시코쿠',
      region7: '규슈・오키나와'
    },
    operation: {
      title: '조작은 간단',
      text1: '이용하고 싶은 시설을 선택합니다. \n 내 주변의 시설을 찾거나, 시설의 이름으로 검색할 수 있습니다.',
      text2: '일람에 시설이 표시되면, 보고 싶은 시설을 선택합니다.',
      text3: '시설의 프로필이 표시됩니다. 전시를 감상할 때는 ‘가이드’를 선택하여 번호를 입력합니다. \n ‘리스트’를 선택하면 전시물의 리스트가 표시됩니다. ‘다운로드’를 선택하면 그 시설의 데이터가 스마트폰에 다운로드 되지만, 데이터는 24시간 후에 삭제됩니다.',
      text4: '전시물에 붙어 있는 번호를 입력하고, ‘결정’을 터치합니다.',
      text5: '전시물의 해설이나 동영상 등의 정보가 표시됩니다. \n 음성이나 동영상이 있는 경우에는 재생 버튼을 터치하여 즐기실 수 있습니다.'
    },
    footer: {
      company: '서비스 운영'
    },
    modal: {
      title: '검색 결과',
      error1: 'There is no facility available near your current location.',
      error2: 'Please enable location services.'
    }
  },
  RU: {
    top: {
      text: 'Совершите прогулку по музеям \n Японии с помощью одного приложения!'
    },
    btnNews: {
      text: 'Уведомления'
    },
    explaination: {
      title: 'О приложении «Карманный экскурсовод»',
      text1: 'С помощью приложения «Карманный экскурсовод» вы сможете ознакомиться с составленным гидами музеев описанием экспонатов или дикторским текстом прямо на вашем смартфоне.',
      text2: 'Установив на свой смартфон приложение «Карманный экскурсовод», вы получите доступ к информации о множестве экспозиций в Японии. Это стало возможно благодаря поддержке со стороны многих музеев.',
      text3: 'Приложение «Карманный экскурсовод» создано специально для любителей музеев. Скачайте это приложение и получите личного гида в ваших путешествиях по музеям.'
    },
    place: {
      title: 'Учреждения, поддерживающие приложение',
      text: 'В настоящий момент вы можете использовать приложение «Карманный экскурсовод» в следующих музеях. \n В будущем планируется увеличение количества учреждений-партнеров. Все для вашего удобства!',
      btn1: 'Поиск объектов поблизости',
      btn2: 'Все',
      region1: 'Хоккайдо',
      region2: 'Тохоку',
      region3: 'Канто',
      region4: 'Тюбу',
      region5: 'Кинки',
      region6: 'Тюгоку и Сикоку',
      region7: 'Кюсю и Окинава'
    },
    operation: {
      title: 'Простое управление',
      text1: 'Выберите учреждение, которое желаете посетить. \n Вы можете найти ближайшие музеи по вашему местоположению на карте, а также воспользоваться поиском по названию.',
      text2: 'В результатах поиска отобразится список музеев, среди которых вы можете выбрать интересующее вас учреждение.',
      text3: 'Просмотр информации о музее. Во время просмотра экспозиции выберите «Путеводитель» и введите номер экспоната.  \n Выбрав «Список», вы можете посмотреть список имеющихся экспонатов. Нажмите «Загрузить», чтобы загрузить данные об экспозиции музея на свое устройство. По прошествии 24 часов данные будут автоматически удалены.',
      text4: 'Введите номер экспоната и нажмите кнопку «ОК».',
      text5: 'Вы увидите описание экспоната, изображения и другую информацию. При наличии аудио- или видеозаписи нажмите кнопку «Воспроизвести».'
    },
    footer: {
      company: 'Разработка сервиса'
    },
    modal: {
      title: 'результат',
      error1: 'There is no facility available near your current location.',
      error2: 'Please enable location services.'
    }
  },
  FR: {
    top: {
      text: 'Parcourez des expositions d\'un bout à l\'autre \n　du Japon grâce à cette application !'
    },
    btnNews: {
      text: 'Informations'
    },
    explaination: {
      title: 'Qu\'est-ce que « Pro des expos en poche » ?',
      text1: '« Pro des expos en poche » est une application gratuite utilisable sur smartphone et vous permettant de profiter d\'explications et narrations lors de vos visites culturelles.',
      text2: 'Avec « Pro des expos en poche », profitez des guides d\'une multitude de musées partenaires à travers tout le Japon.',
      text3: '« Pro des expos en poche », une application pour les amoureux des musées. Pensez à la télécharger lors de votre prochaine visite !'
    },
    place: {
      title: 'Établissements affiliés',
      text: 'L\'application Pro des expos en poche peut être utilisée dans les musées suivants. \n De nombreux lieux affiliés seront ajoutés très prochainement !',
      btn1: 'Chercher un établissement proche',
      btn2: 'Tout',
      region1: 'Hokkaidô',
      region2: 'Région de Tôhoku',
      region3: 'Région de Kantô',
      region4: 'Région de Chûbu',
      region5: 'Région de Kinki',
      region6: 'Chûgoku et Shikoku',
      region7: 'Kyûshû et Okinawa'
    },
    operation: {
      title: 'Simple d\'utilisation,',
      text1: 'Sélectionnez un musée à visiter. \n Vous pouvez effectuer une recherche par nom de lieu ou une géolocalisation près de l\'endroit où vous vous situez.',
      text2: 'Choisissez un lieu à visiter parmi la liste proposée.',
      text3: 'La description du musée s\'affiche à l\'écran. Sélectionnez une exposition, et accédez au « Guide » avec le numéro correspondant.\n Cliquez sur « Liste » pour afficher la liste des expositions. Appuyez sur « Télécharger » pour ensuite télécharger les données d\'un lieu sur votre smartphone. Ces données seront automatiquement effacées après 24 heures.',
      text4: 'Entrez le numéro correspondant à l\'exposition souhaitée, puis appuyez sur le bouton « Confirmer ».',
      text5: 'Une description de l\'exposition ainsi que des images s\'afficheront. \n Si des pistes audio et des vidéos sont disponibles, découvrez-les en appuyant sur le bouton de lecture.'
    },
    footer: {
      company: 'Développeur'
    },
    modal: {
      title: 'Résultat',
      error1: 'There is no facility available near your current location.',
      error2: 'Please enable location services.'
    }
  },
  DE: {
    top: {
      text: 'Erleben Sie Museen \n in ganz Japan mit nur einer App'
    },
    btnNews: {
      text: 'Neuigkeiten'
    },
    explaination: {
      title: 'Was ist Pocket-Kurator?',
      text1: 'Mit „Pocket-Kurator“ können Sie über Ihr Smartphone auf von echten Kuratoren verfasste Erklärtexte und Zusatzinformationen zugreifen, und zwar kostenlos.',
      text2: '„Pocket-Kurator“ dient Ihnen als Führer durch die zahlreichen japanischen Museen, die unser Projekt bereits unterstützen.',
      text3: '„Pocket-Kurator“ ist der perfekte Begleiter für jeden Museumsfreund. Laden Sie ihn bei Ihrem nächsten Museumsbesuch einfach herunter.'
    },
    place: {
      title: 'Einrichtungen, die Pocket-Kurator unterstützen',
      text: '„Pocket-Kurator“ wird zurzeit von den folgenden Museen unterstützt. \n Freuen Sie sich auch schon auf die vielen weiteren Museen, die in Zukunft folgen werden!',
      btn1: 'Nach Einrichtungen in der Nähe suchen',
      btn2: 'Alle',
      region1: 'Hokkaidō',
      region2: 'Region Tōhoku',
      region3: 'Region Kantō',
      region4: 'Region Chūbu',
      region5: 'Region Kinki',
      region6: 'Chūgoku und Shikoku',
      region7: 'Kyūshū und Okinawa'
    },
    operation: {
      title: 'Einfache Bedienung',
      text1: 'Wählen Sie zuerst das Museum, in dem Sie sich befinden. \n Dazu können Sie sich Museen in Ihrer Nähe anzeigen lassen oder über Texteingabe direkt danach suchen.',
      text2: 'Wählen Sie dann aus der angezeigten Liste die gewünschte Einrichtung aus.',
      text3: 'Eine Beschreibung des Museums wird eingeblendet. Wenn Sie nun die Funktion „Führung“ auswählen, gelangen Sie zur Nummerneingabe. \n Wählen Sie die Funktion „Liste“, wird eine Liste aller Ausstellungsobjekte angezeigt. Mittels „Download“ können Sie die vom betreffenden Museum zur Verfügung gestellten Daten auf Ihr Smartphone herunterladen (die Daten werden nach 24 Stunden automatisch gelöscht).',
      text4: 'Geben Sie die zum gewünschten Ausstellungsobjekt gehörige Nummer ein und tippen Sie auf „OK“.',
      text5: 'Zu diesem Ausstellungsobjekt werden nun Begleittexte, Abbildungen und weiteres Wissenswertes angezeigt. Falls Videos oder Tonaufnahmen zur Verfügung stehen, können Sie diese über die Wiedergabetaste abspielen.'
    },
    footer: {
      company: 'Dienstanbieter'
    },
    modal: {
      title: 'Ergebnis',
      error1: 'There is no facility available near your current location.',
      error2: 'Please enable location services.'
    }
  },
  ES: {
    top: {
      text: 'Con una sola app podrá \n pasearse por museos de todo Japón'
    },
    btnNews: {
      text: 'Pulse aquí para notificaciones.'
    },
    explaination: {
      title: '¿Qué es "El Comisario de Bolsillo"?',
      text1: '"El Comisario de Bolsillo" es una aplicación gratuita que le permitirá acceder directamente desde su smartphone a las descripciones y narraciones que van unidos a cada pieza de una exposición de un museo.',
      text2: 'Con "El Comisario de Bolsillo" podrá hacer uso de guías para varios museos de todo Japón, porque en muchos de ellos se ofrece "El Comisario de Bolsillo".',
      text3: '"El Comisario de Bolsillo" es una aplicación especial para los amantes de los museos. Cuando se disponga a visitar un museo, asegúrese de descargársela.'
    },
    place: {
      title: 'Museos que proporcionan el servicio',
      text: 'Actualmente puede usar "El Comisario de Bolsillo" en los siguientes museos. \n Además, está previsto que siga aumentando el número de museos que proporcionan este servicio.',
      btn1: 'Buscar edificios por cercanía',
      btn2: 'Cualquiera',
      region1: 'Hokkaido',
      region2: 'Región de Tohoku',
      region3: 'Región de Kanto',
      region4: 'Región de Chubu',
      region5: 'Región de Kinki',
      region6: 'Chugoku y Shikoku',
      region7: 'Kyushu y Okinawa'
    },
    operation: {
      title: 'Es muy fácil de usar.',
      text1: 'Primero, busque el museo para el que quiere guía. \n Puede buscar museos cercanos a su ubicación, o buscar un museo en concreto escribiendo su nombre.',
      text2: 'Cuando se muestre el listado de museos, deberá escoger el que desea visitar.',
      text3: 'Entonces aparecerá el perfil de ese museo. Cuando visite una de sus exposiciones, elija la opción Guía. A continuación deberá introducir el número. \n Si elije la opción Lista, aparecerá la lista de exposiciones. Si pulsa Descargar, los datos de esa exposición se le descargarán al smartphone, aunque después de 24 horas se borrarán.',
      text4: 'Introduzca los números correspondientes a las piezas de la exposición y pulse Seleccionar',
      text5: 'Así verá información sobre la exposición, ya sean textos descriptivos, imágenes, etc. Si hay guías de voz y vídeo disponibles, pulse el botón de reproducción para disfrutar de ellos.'
    },
    footer: {
      company: 'Proveedores del servicio'
    },
    modal: {
      title: 'Resultado',
      error1: 'There is no facility available near your current location.',
      error2: 'Please enable location services.'
    }
  },
  PT: {
    top: {
      text: 'Visite vários museus \n no Japão com uma só aplicação'
    },
    btnNews: {
      text: 'Notícias'
    },
    explaination: {
      title: 'O que é o "Curador de Bolso"?',
      text1: 'O "Curador de Bolso" é uma aplicação gratuita que lhe permite descobrir explicações e narrações fornecidas pelos curadores em cada peça directamente no seu smartphone.',
      text2: 'Com o "Curador de Bolso", pode usufruir de uma grande variedade de guias para museus no Japão. Tudo graças ao facto de muitas instalações utilizarem o "Curador de Bolso"',
      text3: 'O "Curador de Bolso" é a aplicação perfeita para adeptos de museus. Experimente da próxima vez que visitar um museu!',
      text7: 'Estabelecimentos compatíveis com a aplicação'
    },
    place: {
      title: 'Estabelecimentos compatíveis com a aplicação',
      text: 'De momento, o "Curador de Bolso" pode ser utilizado nos museus abaixo indicados. \n Temos planos para expandir o número de instalações que utilizam este serviço.',
      btn1: 'Procurar estabelecimentos perto da sua localização atual',
      btn2: 'Tudo',
      region1: 'Hokkaido',
      region2: 'Região de Tohoku',
      region3: 'Região de Kanto',
      region4: 'Região de Chubu',
      region5: 'Região de Kinki',
      region6: 'Chugoku e Shikoku',
      region7: 'Kyushu e Okinawa'
    },
    operation: {
      title: 'Fácil de utilizar',
      text1: 'Escolha o estabelecimento que pretende visitar. \n Procure pela sua localização actual ou pelo nome do estabelecimento. ',
      text2: 'De seguida, é apresentada uma lista com vários estabelecimentos, a partir da qual pode escolher aquele que quer visitar.',
      text3: 'Será apresentado o perfil do estabelecimento. Quando estiver a visitar a exposição, escolha "Guia" e introduza o número do objecto. \n A opção "Lista" apresenta uma lista dos objectos em exposição. A opção "Descarregar" permite descarregar os dados do estabelecimento para o seu smartphone, sendo que serão apagados após 24 horas.',
      text4: 'Introduza o número correspondente ao objecto em exposição e clique em "Confirmar".',
      text5: 'Serão apresentadas informações sobre o objecto, como explicações e imagens. \n No caso de existirem ficheiros de áudio ou vídeo, pode também reproduzi-los ao clicar no botão "Reproduzir".'
    },
    footer: {
      company: 'Administrador do serviço'
    },
    modal: {
      title: 'Resultado',
      error1: 'There is no facility available near your current location.',
      error2: 'Please enable location services.'
    }
  },
  IT: {
    top: {
      text: 'Questa app vi accompagnerà \n attraverso i musei del Giappone!'
    },
    btnNews: {
      text: 'Informazioni'
    },
    explaination: {
      title: 'Descrizione di "Guida tascabile"',
      text1: 'Con l\'app gratuita "Guida tascabile" potrai goderti sul tuo smartphone i commenti e le descrizioni che i curatori hanno allegato agli oggetti esposti nei musei.',
      text2: 'Potrai utilizzare "Guida tascabile" in moltissimi musei del Giappone. Infatti, molte strutture fanno uso dei nostri servizi.',
      text3: '"Guida tascabile" è una app creata per gli amanti dei musei. Prova a scaricarla mentre ne esplori uno!'
    },
    place: {
      title: 'Strutture affiliate',
      text: 'Al momento è possibile utilizzare "Guida tascabile" nei seguenti musei. \n Prevediamo di aumentarne il numero, siamo sicuri che ne rimarrete soddisfatti!',
      btn1: 'Cerca edifici vicini',
      btn2: 'Tutti',
      region1: 'Hokkaido',
      region2: 'Regione di Tohoku',
      region3: 'Regione di Kanto',
      region4: 'Regione di Chubu',
      region5: 'Regione di Kinki',
      region6: 'Chugoku e Shikoku',
      region7: 'Kyushu e Okinawa'
    },
    operation: {
      title: 'Utilizzarla è davvero molto semplice.',
      text1: 'Per prima cosa, seleziona la struttura che vuoi visitare. \n Potrai cercare automaticamente i musei più vicini a te o inserirne il nome.',
      text2: 'Seleziona il museo dall\'elenco che verrà visualizzato.',
      text3: 'Avrai così accesso al profilo della struttura. Per avere informazioni su un\'esposizione, seleziona "Guida" e quindi inserisci il numero. \n Selezionando "Lista", apparirà una lista degli oggetti esposti. Selezionando "Download", verranno scaricati sullo smartphone tutti i dati relativi al museo, ma verranno cancellati dopo 24 ore.',
      text4: 'Digita il numero associato all\'oggetto esposto e premi "Conferma".',
      text5: 'Appariranno le informazioni ad esso collegate, come testi e immagini. Nel caso di contenuti audio o video, basterà premere il tasto di riproduzione per farli partire.'
    },
    footer: {
      company: 'Gestione del servizio'
    },
    modal: {
      title: 'risultato',
      error1: 'There is no facility available near your current location.',
      error2: 'Please enable location services.'
    }
  },
  TH: {
    top: {
      text: 'ลองเริ่มต้นเที่ยวชมพิพิธภัณฑ์ทั่วประเทศญี่ปุ่น \n ไปกับแอปพลิเคชันหนึ่งเดียวนี้ด้วยกัน'
    },
    btnNews: {
      text: 'ข่าวประชาสัมพันธ์ กดที่นี่'
    },
    explaination: {
      title: '"ภัณฑารักษ์ในกระเป๋า" หมายถึง?',
      text1: '"ภัณฑารักษ์ในกระเป๋า" คือ แอปพลิเคชันฟรีที่ท่านจะได้เพลิดเพลินไปกับคำอธิบาย เสียงบรรยายและการนำเสนอในรูปแบบต่างๆ จากภัณฑารักษ์ ว่าด้วยเรื่องราวที่จัดแสดงไว้ในแต่ละพิพิธภัณฑ์ที่ท่านเช้าชม',
      text2: 'แอป "ภัณฑารักษ์ในกระเป๋า" จะช่วยให้ท่านสามารถใช้บริการไกด์นำชมพิพิธภัณฑ์ซึ่งมีอยู่เป็นจำนวนมากทั่วประเทศญี่ปุ่นได้ เนื่องจากปัจจุบันพิพิธภัณฑ์หรือสถานที่จัดแสดงจำนวนมากได้เริ่มต้นใช้แอป "ภัณฑารักษ์ในกระเป๋า" นี้แล้ว',
      text3: '"ภัณฑารักษ์ในกระเป๋า" เป็นแอปที่ออกแบบมาเพื่อช่วยท่านค้นหา "พิพิธภัณฑ์ในดวงใจ" ของท่าน จึงขอให้ท่านไม่พลาดดาวน์โหลดแอปนี้ไว้ เพื่อใช้งานในระหว่างที่ท่านเยี่ยมชมพิพิธภัณฑ์ต่างๆ'
    },
    place: {
      title: 'สถานที่ที่ให้บริการ',
      text: 'ปัจจุบัน ท่านสามารถใช้บริการ "ภัณฑารักษ์ในกระเป๋า" \n ได้ตามพิพิธภัณฑ์ที่มีรายชื่อดังต่อไปนี้ โดยหลังจากนี้จำนวนสถานที่ที่สามารถใช้บริการนี้ได้จะเพิ่มขึ้นอีก ขอท่านได้โปรดติดตามต่อไป',
      btn1: 'ค้นหาพิพิธภัณฑ์ที่ใกล้กับจุดที่อยู่ปัจจุบัน',
      btn2: 'ทั้งหมด',
      region1: 'ฮอกไกโด',
      region2: 'โทโฮคุ',
      region3: 'คันโต',
      region4: 'จูบุ',
      region5: 'คินคิ',
      region6: 'จูโกคุ,ชิโกคุ',
      region7: 'คิวชู,โอกินาวา'
    },
    operation: {
      title: 'ใช้งานง่าย',
      text1: 'เลือกสถานที่จัดแสดงที่ท่านต้องการ \n เพียงเท่านี้ ท่านจะสามารถค้นหาสถานที่จัดแสดงใกล้ตำแหน่งปัจจุบันของท่านได้ รวมถึง สามารถค้นหาจากชื่อของสถานที่จัดแสดงได้ด้วยเช่นกัน',
      text2: 'เมื่อหน้าจอปรากฏรายชื่อสถานที่จัดแสดงขึ้นมาจำนวนหนึ่งแล้ว ให้ท่านเลือกสถานที่ที่ท่านต้องการเข้าชม',
      text3: 'จะปรากฏข้อมูลเฉพาะของสถานที่จัดแสดงนั้น หากท่านต้องรับชมสิ่งที่จัดแสดงไว้ในสถานที่นั้น กรุณาเลือกต่อที่คำว่า "ไกด์" ตามด้วยการกรอกหมายเลข \n เมื่อกดเลือก "รายการ" จะปรากฏรายการสิ่งที่จัดแสดง หากท่านกดเลือก "ดาวน์โหลด" ข้อมูลของสถานที่นั้นจะถูกดาวน์โหลดเข้าเครื่องสมาร์ทโฟนของท่าน ข้อมูลดังกล่าวจะถูกลบไปเมื่อพ้น 24 ชั่วโมงหลังการดาวน์โหลด',
      text4: 'กรอกหมายเลขประจำสิ่งจัดแสดงนั้น ตามด้วยการกดแทป "ตกลง"',
      text5: 'ที่หน้าจอจะปรากฏข้อมูลต่างๆ เช่น คำอธิบาย รูปภาพของสิ่งของที่จัดแสดง กรณีที่มีคำบรรยายเป็นเสียงหรือมีภาพเคลื่อนไหว กรุณากดปุ่มเล่น หรือ Play เพื่ออรรถรสในการรับชม'
    },
    footer: {
      company: 'การประกอบการให้บริการ'
    },
    modal: {
      title: 'ผล',
      error1: 'There is no facility available near your current location.',
      error2: 'Please enable location services.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/text/index.js